import type { ContractInterface, PageableContent } from '@/types'
import api from '@/utils/api/api'

import type {
  ContractsPageParams,
  UpdateContractRequest,
} from '../types/contracts.types'

type RequestOptions = {
  signal?: AbortSignal
}

type ContractsListResponse = { contracts: PageableContent<ContractInterface> }

type ContractResponse = { contract: ContractInterface }

const getContractsPath = (organisationId: string) =>
  `/organisations/${organisationId}/contracts`

export const contractsApi = {
  getContracts: async (
    organisationId: string,
    params: ContractsPageParams,
    options?: RequestOptions
  ) => {
    const { data } = await api.get<ContractsListResponse>(
      getContractsPath(organisationId),
      { params, signal: options?.signal }
    )
    return data.contracts
  },
  updateContract: async (
    organisationId: string,
    contractId: string,
    payload: UpdateContractRequest
  ) => {
    const { data } = await api.put<ContractResponse>(
      `${getContractsPath(organisationId)}/${contractId}`,
      payload
    )
    return data.contract
  },
}
